import { format, add } from 'date-fns'
import times from 'lodash/times'
import qs from 'query-string'
import { Referral } from '@/types'
import analytics from '@/shared-utils/analytics'
import { ANALYTICS_CATEGORY_HOME } from '@/constants/analytics'

export const trackCruisesSubmit = (values: {
  location: string
  cruiseLine: string
  startDate: string
  zip: string
  duration: string
  under55: string
}) => {
  const data = [
    `Destination_${values.location}`,
    `Cruise line_${values.cruiseLine}`,
    `Zip Code_${values.zip}`,
    `Departure Date ${values.startDate}`,
    `Cruise Length_${values.duration}`,
    `55 years or older_${values.under55 ? 'N' : 'Y'}`
  ].join('|')
  analytics.fireEvent({
    action: 'Cruises Search Button',
    category: ANALYTICS_CATEGORY_HOME,
    data
  })
  analytics.fireEvent({
    action: 'Cruises Search',
    category: ANALYTICS_CATEGORY_HOME,
    data: 'Valid'
  })
}

export const handleSubmit =
  (
    data: {
      location: string
      cruiseLine: string
      zip: string
      startDate: string
      duration: string
      under55: string
    },
    referral: Referral
  ) =>
  (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const { location, cruiseLine, zip, startDate, duration, under55 } = data

    const query = `?${qs.stringify({
      places: location,
      operator: cruiseLine,
      Month: startDate,
      days: duration,
      shoppingZipCode: zip,
      IncludeSeniorRates: under55 === 'true',
      sort_by: 7,
      refId: referral.id,
      refClickId: referral.clickId
    })}`

    trackCruisesSubmit(data)

    window.open(`//cruises.priceline.com/results.do${query}`)
  }

export const currentMonth = format(new Date(), 'MM/1/yyyy')

export const createDateOptions = (date: Date) => {
  const options: Array<{ value: string; label: string }> = []
  const parseOptions = (i: number) => {
    const newMonth = add(date, {
      months: i
    })
    const monthDate = format(newMonth, 'MM/1/yyyy')
    options.push({
      value: monthDate,
      label: format(newMonth, 'MMMM yyyy')
    })
  }

  times(24, parseOptions)
  return options
}
